export default function newsletterTemplate(mealplan, recipes = [], tips = []) {
  const month = mealplan.date
    ? new Date(mealplan.date).toLocaleString('en-GB', { month: 'long' })
    : '';
  const planTitle = mealplan.title || '';
  const heroImage = mealplan.images?.[0]?.src || '';
  const heroAlt = mealplan.images?.[0]?.alt || planTitle;
  const stripHtml = (html) => html ? html.replace(/<[^>]+>/g, '') : '';
  const planDescription = stripHtml(mealplan.description) || '';
  const planLink = mealplan.share_link || '';
  const recipeCards = recipes.slice(0, 4).map(recipe => `
    <table width="100%" cellpadding="0" cellspacing="0" bgcolor="#fff" style="border-radius: 16px; margin-bottom:16px;">
      <tr>
        <td width="100" valign="top">
          <img src="${recipe.images?.[0]?.src || ''}" alt="${recipe.title}" width="100" height="100" style="display:block; border-radius: 16px 0 0 16px;object-fit: cover;">
        </td>
        <td style="padding: 8px; vertical-align: middle; width:100%;">
          <p style="margin: 0; font-weight: bold; font-size: 16px;">${recipe.title}</p>
          <p style="margin: 8px 0 0 0;color:#333;font-size:12px;">
            <span style="margin-top: 8px;color:#333;padding:2px 6px;border: 1px solid #333;border-radius:10px;font-size:12px;">${recipe.total_time || ''}</span>
          </p>
        </td>
      </tr>
    </table>
  `).join('\n');

  // Use mealplan tips if provided, otherwise fallback to example tips
  const tipsList = (tips && tips.length)
    ? tips.map(tip => `<li>${tip.value}</li>`).join('\n')
    : `
      <li>Cook once, portion twice: most of these recipes keep well in the fridge or freezer, perfect for busy nights.</li>
      <li>Risotto hack: make a double batch, and use leftovers to form crispy risotto cakes for lunch.</li>
      <li>Stroganoff swap: no chestnut mushrooms? Try button mushrooms and add a splash of soy sauce for depth.</li>
    `;

  return `<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8">
    <title>Feeds – ${month} Meal Plan</title>
    <style>
      @font-face {
      font-family: Omnes;
        src: url('https://admin.feedsfeedsfeeds.com/fonts/omnes-black.otf');
      }
    </style>
  </head>
  <body style="margin:0;padding:0;background-color:#f2eeea;font-family:Helvetica, Arial, sans-serif;color:#2f413d;">
    <table width="100%" cellpadding="0" cellspacing="0" border="0" bgcolor="#f2eeea">
      <tr>
        <td align="center">
          <table width="600" cellpadding="0" cellspacing="0" border="0" bgcolor="#f2eeea" style="overflow:hidden;">
            <tr>
              <td align="center" style="padding: 20px;">
                <img src="https://images.squarespace-cdn.com/content/6620f0f97801104d3f8d6162/efea19b1-3699-4ee7-9e8f-64ef6d68f411/Feeds+logo.png" alt="Feeds Logo" width="120" style="display:block;">
              </td>
            </tr>
            <table width="600" cellpadding="0" cellspacing="0" border="0" bgcolor="#fef7ed" style="overflow:hidden;border-radius:40px;">
              <tr>
                <td align="center">
                  <img src="${heroImage}" alt="${heroAlt}" width="600" height="400" style="width:100%;display:block;border-radius:0;aspect-ratio: 1.333;object-fit: cover;">
                </td>
              </tr>
              <tr>
                <td style="padding: 25px 20px 10px 20px;">
                  <p style="margin: 0 0 0px 0; font-size: 12px; text-transform: uppercase; letter-spacing: 0.5px;">${month} Meal Plan</p>
                  <h1 style="font-family: Omnes, Helvetica, Arial, sans-serif; margin: 0; font-size: 24px; font-weight: bold;">${planTitle.toUpperCase()}</h1>
                  <p style="margin: 15px 0 0 0; font-size: 16px; line-height: 1.5;">
                    ${planDescription}
                  </p>
                </td>
              </tr>
              <tr>
                <td style="padding: 30px 20px 10px 20px;">
                  <h2 style="margin: 0 0 8px 0; font-size: 18px;">🍽️ What's on the Menu</h2>
                </td>
              </tr>
              <tr>
                <td style="padding: 0 20px;">
                  ${recipeCards}
                  <table width="100%" cellpadding="0" cellspacing="0">
                    <tr>
                      <td align="center" style="padding: 20px 0;">
                        <a href="${planLink}" style="background:#f26b3d;color:#ffffff;text-decoration:none;padding:12px 32px;border-radius:50px;font-weight:bold;font-size:16px;display:inline-block;">Open the plan</a>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <!-- Swap Section -->
              <tr>
                <td style="padding: 10px 20px;">
                  <h2 style="margin: 0 0 10px 0; font-size: 18px;">🌱 Family Favourites, Reimagined #2</h2>
                  <p style="margin: 0 0 10px 0; font-size: 16px; line-height: 1.5;">
                    The hero of this month’s plan is <strong>Shepherdless Pie</strong> — our second instalment in the Family Favourites, Reimagined series. It’s the same comfort you know and love, just reimagined with lentils instead of mince. Rich, hearty, and freezer-friendly.
                  </p>
                  <p style="margin: 0;font-size: 16px;"><a href="https://feedsfeedsfeeds.com/blog/shepherdless-pie-recipe" style="color:#2f413d;text-decoration:underline;">Read the blog post →</a></p>
                </td>
              </tr>
              <!-- Tips -->
              <tr>
                <td style="padding: 20px 20px 0 20px;">
                  <h2 style="margin: 0 0 10px 0; font-size: 18px;">🧠 Quick tips</h2>
                  <ul style="padding-left: 20px; margin: 0; font-size: 16px; line-height: 1.5;">
                    ${tipsList}
                  </ul>
                </td>
              </tr>
              <!-- From the Team -->
              <tr>
                <td style="padding: 25px 20px 0 20px;">
                  <h2 style="margin: 0 0 10px 0; font-size: 18px;">👋 From the Team</h2>
                  <p style="margin: 0 0 10px 0; font-size: 16px; line-height: 1.5;">
                    As a two–person team, we’re always balancing things behind the scenes. Last month, one of us got to soak up some sun (and plenty of food inspiration) in Spain, while the other held down the fort. Now we’re back and working on a feature many of you asked for: changing servings directly in your shopping list. We can’t wait to roll it out soon.
                  </p>
                  <p style="margin: 0 0 10px 0; font-size: 16px; line-height: 1.5;">
                    Thanks for supporting Feeds, it really means a lot.</p>
                  <p style="margin: 0 0 20px 0;font-size: 16px;">BM & Bernard</p>
                  <table width="100%">
                    <tr>
                      <td align="center">
                        <a href="${planLink}" style="background:#f26b3d;color:#ffffff;text-decoration:none;padding:12px 32px;border-radius:50px;font-weight:bold;font-size:16px;display:inline-block;">Start cooking</a>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
              <!-- Footer -->
              <tr>
                <td style="padding: 30px 20px 40px 20px; text-align: center; font-size: 12px; color: #888;">
                  You’re receiving this email because you signed up for Feeds.<br>
                  <a href="[unsubscribe_url]" style="color:#888;text-decoration:underline;">Unsubscribe</a>
                </td>
              </tr>
            </table>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>`;
}